<template>
  <div class="mesh-selector__mesh-item">
    <button class="mesh-selector__button button button__outlined button__rounded"
            :class="selectedMesh === mesh ? 'mesh-selector__button--active' : '' "
            @click="selectMesh()"> {{ mesh.name | cleanMeshName }}</button>
    <mesh-selector-mesh-details :mesh="mesh"></mesh-selector-mesh-details>
  </div>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import MeshSelectorMeshDetails from './MeshSelectorMeshDetails';

  export default {
    name: "MeshSelectorButton",
    components: {
      MeshSelectorMeshDetails,
    },
    props: {
      mesh: {
        type: Object,
        required: true,
      }
    },
    computed: {
      ...mapGetters('clothes',[
        'selectedDress',
        'selectedMesh',
        'meshesOfDress',
        'accessoriesOfDress'
      ]),
    },
    filters: {
      cleanMeshName: function(name) {
        if(!name) {
          return '';
        }

        // console.log(name.split('-').pop().replace('ACC_',''));

        let cleanedName = name.split('-').pop();
        cleanedName = cleanedName.replaceAll('ACC_','');
        cleanedName = cleanedName.replaceAll('_',' ');
        cleanedName = cleanedName.toUpperCase();
        // console.log(cleanedName);
        return cleanedName;

      }
    },
    methods: {
      ...mapActions('clothes',[
        'setSelectedMesh'
      ]),
      ...mapActions('camera',[
        'focusOnSelectedMesh'
      ]),
      ...mapActions([
        'render'
      ]),
      selectMesh() {
        this.focusOnSelectedMesh(this.mesh);
        this.setSelectedMesh(this.mesh);
      }
    },
  }
</script>

<style scoped>
  .mesh-selector__mesh-item {
    /*border-bottom: 1px solid #CAC8C8;*/
    /*margin-bottom: 15px;*/
  }

  .mesh-selector__button {
    width: max-content;
    /*margin-right: 15px;*/
    opacity: 0.6;
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    font-size: 12px;
    white-space: nowrap;
    background-color: rgba(255,255,255,0.4);
  }

  .mesh-selector__button--active {
    border-color: red;
    color: red;
    opacity: 1;
  }

  .selector__title {
    font-size: 12px;
  }

  .selected__image {
    height: 70px;
    width: 70px;
    border-radius: 70px;
    object-fit: cover;
  }
</style>